import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface ProjectLocationState {
    CreateProjectlocation: Record<string, any>; 
}


const initialState: ProjectLocationState = {
    CreateProjectlocation: {},
};

const projectLocationSlice = createSlice({
    name: "projectLocation",
    initialState,
    reducers: {
        setProjectLocation: (state, action: PayloadAction<Record<string, any>>) => {
            state.CreateProjectlocation = action.payload;
        },
        resetProjectLocation: (state) => {
            state.CreateProjectlocation = {};
        },
    },
});

export const { setProjectLocation, resetProjectLocation } = projectLocationSlice.actions;
export default projectLocationSlice.reducer;